import LCSVisualizer from "./LCSVisualizer";

export default function Lcs() {
  return <LCSVisualizer />
}
